import { render, staticRenderFns } from "./ProjectsPageSecondaryMarket.vue?vue&type=template&id=843b1d1c&"
import script from "./ProjectsPageSecondaryMarket.vue?vue&type=script&lang=js&"
export * from "./ProjectsPageSecondaryMarket.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPageSecondaryMarket.vue?vue&type=style&index=0&id=843b1d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports